// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"DemoStart_cardWrapper__20ecB","enter":"DemoStart_enter__1vzoa"};